import { render } from "./index.vue?vue&type=template&id=dc543b4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=dc543b4c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc543b4c"],['__file',"src/extra/VabDialog/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc543b4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc543b4c', __exports__)) {
    console.log('reload')
    api.reload('dc543b4c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=dc543b4c&scoped=true", () => {
    console.log('re-render')
    api.rerender('dc543b4c', render)
  })

}


export default __exports__